<template>
<g>
  <complexagon
    v-for="(hexagon, index) in hexagons"
    :key="id + '-' + index"
    :id="id * size + index"
    :groupId="id"
    :value="hexagon.value"
    :x="getX(index)"
    :y="getY(index)"
    :angle="0"
    :gradient="{x1: 0, x2: 0, y1: 0, y2: 1}"
    :gradientSpread="gradientSpread"
    :scale="scale"
    :curve="curve"
    :onColor="hexagon.onColor"
    :offColor="hexagon.offColor"
    @hc-hover="onHover"
    class="hc-hexabar-complexagon"
  />
</g>
</template>

<script>
import Complexagon from './combo/Complexagon'
export default {
  name: 'Hexabar',
  components: {
    Complexagon
  },
  props: {
    data: {
      type: Array,
      default () {return []}
    },
    id: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 360
    },
    width: {
      type: Number,
      default: 96
    },
    curve: {
      type: Number,
      default: 1
    },
    colors: {
      type: Array,
      default () { return ['#9c756e', '#f67055']}
    },
    offColor: {
      type: String,
      default: '#757575'
    },
    size: {
      type: Number,
      default: 100
    },
    columns: {
      type: Number,
      default: 5
    },
    rows: {
      type: Number,
      default: 20
    },
    onHover: {
      type: Function,
      default () {}
    },
    x: {
      type: Number,
      default: 0
    },
    scale: {
      type: Number,
      default: 1
    },
    gradientSpread: {
      type: Number,
      default: .5
    }
  },
  methods: {
    getValue (index) {
      if (index >= 50 && index < 55) {
        return .6
      }
      if (index >= 55 && index < 60) {
        return .4
      }
      return 1
    },
    getOnColor (index) {
      if (index >= 55) {
        return '#f67055'
      }
      if (index >= 50) {
        return '#9c756e'
      }
      return this.offColor
    },
    getOffColor (index) {
      if (index >= 55) {
        return '#9c756e'
      }
      return this.offColor
    },
    getX (index) {
      return this.x + ((index % this.columns) * 30 + ((Math.floor(index / this.columns) % 2) ? 15 : 0)) * this.scale + (1 - this.scale) * 2.5 * this.width / 30
    },
    getY (index) {
      return this.height * .9 - Math.floor(index / this.columns) * 26 * this.scale
    }
  },
  computed: {
    hexagons () {
      let hexagons = []
      for (let i = 0; i < this.size; i++) {
        hexagons.push({
          x: this.getX(i),
          y: this.getY(i),
          value: this.getValue(i),
          onColor: this.getOnColor(i),
          offColor: this.getOffColor(i)
        })
      }
      return hexagons
    }
  }
}
</script>

<style>

</style>
